module.exports = __webpack_public_path__ + "img/cz.e234c86e.png";